// extracted by mini-css-extract-plugin
var _1 = "GroupIcon-module__animateUploadProgressBarWidth--oGOU4";
var _2 = "GroupIcon-module__animatedBackground--o2P1_";
var _3 = "GroupIcon-module__container--hHAEI";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container" }
